import LandingPage from "../components/landingPage/landingPage";
import Layout from "../components/layOutWrapper/layOutWrapper";

export default function LandingView () {
    return (
        <Layout children={LandingPage()} sectionTitle=""/>
    )
}